import type { CameraDistanceId } from './presets.js';
const anchors = { wide: 24, standard: 50, close: 100, 'x-close': 200, 'xx-close': 400, 'telephoto-800': 800 } as const;
export const lensForCameraDistance = (distance: CameraDistanceId) => anchors[distance];
/** Gimbal policy follows magnification, including intermediate authored focal lengths. */
export function cameraDistanceForLens(lens: number): CameraDistanceId {
  return lens <= 24 ? 'wide' : lens <= 50 ? 'standard' : lens <= 100 ? 'close' : lens <= 200 ? 'x-close' : lens <= 400 ? 'xx-close' : 'telephoto-800';
}
